import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "leavingSiteNoticeModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "leavingSiteNoticeModalTitle",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header text-bg-primary" }
const _hoisted_5 = {
  class: "modal-title",
  id: "leavingSiteNoticeModalTitle"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_8 = ["href", "target"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _renderSlot(_ctx.$slots, "title")
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            "aria-label": "Cancel",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.cancelClick && $options.cancelClick(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          ($data.messageType === 'page')
            ? _renderSlot(_ctx.$slots, "page-message", { key: 0 }, () => [
                _createTextVNode("[Leaving Site Page Message]")
              ])
            : _createCommentVNode("v-if", true)
        ]),
        ($data.anchor)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-info",
                onClick: _cache[1] || (_cache[1] = (...args) => ($options.cancelClick && $options.cancelClick(...args)))
              }, [
                _renderSlot(_ctx.$slots, "cancel", {}, () => [
                  _createTextVNode("[Cancel]")
                ])
              ]),
              _createElementVNode("a", {
                class: "btn btn-primary",
                href: $data.anchor.href,
                target: $data.anchor.target,
                "data-leaving-site-bypass": "",
                onClick: _cache[2] || (_cache[2] = (...args) => ($options.continueClick && $options.continueClick(...args)))
              }, [
                _renderSlot(_ctx.$slots, "continue", {}, () => [
                  _createTextVNode("[Continue]")
                ])
              ], 8 /* PROPS */, _hoisted_8)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}